<template>
  <div class="comp-bing-data-sync">
    <jw-modal v-model:visible="visible" :title="title" title-align="start" width="480px" :ok-loading="loading">
      <template #footer>
        <jw-button @click="handleCancel">取消</jw-button>
        <jw-button type="primary" @click="handleOk">确认</jw-button>
      </template>
      <jw-form :model="form" label-align="right" auto-label-width ref="asyncDataFormRef" @submit="handleSubmit">
        <template v-if="type == 2">
          <jw-form-item field="dataRadio" :label="$t('同步内容')" show-colon :rules="{ required: true, message: $t('请选择同步内容') }" :validate-trigger="['change']">
            <jw-radio-group v-model="form.dataRadio">
              <jw-radio value="1">按客户创建日期</jw-radio>
              <jw-radio value="2">全部客户</jw-radio>
            </jw-radio-group>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == '1'" field="timeDate" :label="$t('客户创建日期')" show-colon :rules="{ required: true, message: $t('请选择客户创建日期') }" :validate-trigger="['change']">
            <jw-range-picker v-model="form.timeDate" style="width: 300px" />
          </jw-form-item>
          <div>
            <div style="margin-left: 10px; color: var(--color-text-3)">
              <div>● 从Bing后台同步所选日期范围内创建的客户或全部客户。</div>
              <div>● 数据同步需要一定的时间，以下操作可更快同步数据。</div>
            </div>
            <div style="margin-left: 20px; color: var(--color-text-3)">
              <div>ㅇ 选择按客户创建日期同步；</div>
              <div>ㅇ 选择较小的日期范围；</div>
              <div>ㅇ 等待此次同步数据结束后在进行下次数据同步；</div>
            </div>
          </div>
        </template>
        <template v-else-if="type_invite == true">
          <jw-form-item field="dataRadio" :label="$t('同步内容')" show-colon :rules="{ required: true, message: $t('请选择同步内容') }" :validate-trigger="['change']">
            <jw-radio-group v-model="form.dataRadio" direction="vertical">
              <jw-radio value="1">指定客户的数据</jw-radio>
              <jw-radio value="2">全部邀请数据</jw-radio>
            </jw-radio-group>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == 1" field="selectdata" :label="$t('选择客户')" show-colon :rules="{ required: true, message: $t('请选择客户') }" :validate-trigger="['change']">
            <jw-select v-model="form.selectdata" :placeholder="$t('请选择客户')" :style="{ width: '300px' }" allow-clear allow-search :virtual-list-props="{ height: 200 }" :options="selectList" multiple> </jw-select>
          </jw-form-item>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>可从Bing后台同步指定客户的邀请数据，或全部邀请数据。</div>
          </div>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>全部邀请数据同步需要一定的时间，请尽量选择指定客户邀请数据。</div>
          </div>
        </template>
        <template v-else-if="type == 3">
          <jw-form-item field="dataRadio" :label="$t('同步内容')" show-colon :rules="{ required: true, message: $t('请选择同步内容') }" :validate-trigger="['change']">
            <jw-radio-group v-model="form.dataRadio" direction="vertical">
              <jw-radio value="1">指定客户的账户数据</jw-radio>
              <jw-radio value="2">指定状态的账户数据</jw-radio>
              <jw-radio value="3">全部账户数据</jw-radio>
            </jw-radio-group>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == 1" field="selectdata" :label="$t('选择客户')" show-colon :rules="{ required: true, message: $t('请选择客户') }" :validate-trigger="['change']">
            <jw-select v-model="form.selectdata" :placeholder="$t('请选择客户')" :style="{ width: '300px' }" allow-clear allow-search :virtual-list-props="{ height: 200 }" :options="selectList" multiple> </jw-select>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == 2" field="accountStatus" :label="$t('账户状态')" show-colon :rules="{ required: true, message: $t('请选择账户状态') }" :validate-trigger="['change']">
            <jw-select v-model="form.accountStatus" :placeholder="$t('请选择账户状态')" :style="{ width: '300px' }" allow-clear allow-search :options="accountLifeCycleStatus"> </jw-select>
          </jw-form-item>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>可从Bing后台同步指定客户的账户数据，或指定状态的账户数据，或全部账户数据。</div>
          </div>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>指定状态的账户数据同步需要一定的时间，请尽量选择指定客户的账户数据进行同步。</div>
          </div>
        </template>
        <template v-else-if="type == 10">
          <jw-form-item field="dataRadio" :label="$t('同步内容')" show-colon :rules="{ required: true, message: $t('请选择同步内容') }" :validate-trigger="['change']">
            <jw-radio-group v-model="form.dataRadio" direction="vertical">
              <jw-radio value="1">指定账户的订单数据</jw-radio>
              <!-- <jw-radio value="2">指定日期的订单数据</jw-radio> -->
              <jw-radio value="3">全部订单数据</jw-radio>
            </jw-radio-group>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == 1" field="selectdata" :label="$t('选择账户')" show-colon :rules="{ required: true, message: $t('请选择') }" :validate-trigger="['change']">
            <jw-select v-model="form.selectdata" :placeholder="$t('请选择')" :style="{ width: '300px' }" allow-clear allow-search :virtual-list-props="{ height: 200 }" :options="selectList" multiple> </jw-select>
          </jw-form-item>
          <jw-form-item v-if="form.dataRadio == '2'" field="timeDate" :label="$t('日期范围')" show-colon :rules="{ required: true, message: $t('请选择创建日期') }" :validate-trigger="['change']">
            <jw-range-picker v-model="form.timeDate" style="width: 300px" />
          </jw-form-item>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>可从Bing后台同步指定账户的订单数据，或全部订单数据。</div>
          </div>
          <div style="display: flex; margin-right: 20px; margin-left: 10px; color: var(--color-text-3)">
            <div style="margin-right: 10px">●</div>
            <div>全部订单数据同步需要一定的时间，请尽量选择指定账户同步订单数据。</div>
          </div>
        </template>
      </jw-form>
    </jw-modal>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { publicService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import dayjs from 'dayjs';
import useLoading from '@/hooks/loading';
const { loading, setLoading } = useLoading(false);
console.log('1-开始创建组件-setup');
const visible = ref(false);
const form = ref({
  timeDate: [Date.now(), Date.now()], //客户日期选择
  dataRadio: '1', //radio选项
  selectdata: [],
  accountStatus: '' //账户状态
});
const emits = defineEmits(['cb']);
const selectList = ref([]);
const accountLifeCycleStatus = ref([
  { label: '活动', value: 'Active' },
  { label: '草稿', value: 'Draft' },
  { label: '已停用', value: 'Inactive' },
  { label: '暂停', value: 'Pause' },
  { label: '挂起状态', value: 'Pending' },
  { label: '因可疑活动被暂停', value: 'Suspended' }
]);
const asyncDataFormRef = ref();
const type = ref(null); //type=2客户,type=3商机 type = 10 销售订单
const type_invite = ref(false); //type=2客户 邀请同步数据
const title = ref(null);
// 打开弹窗
const open = async (params) => {
  visible.value = true;
  asyncDataFormRef.value.clearValidate();
  type.value = params?.type;
  type_invite.value = params?.type_invite;
  title.value = params?.title ? params?.title : 'Bing数据同步';
  form.value.selectdata = [];
  form.value.accountStatus = '';
  form.value.dataRadio = '1';

  if (type_invite.value) {
    await getSimpleListByEntity(2); // 获取客户数据
  }

  if (type.value == 3) {
    await getSimpleListByEntity(2);
  }
  if (type.value == 10) {
    await getSimpleListByEntity(3);
  }
};

// 获取 客户或销售订单 下列表
const getSimpleListByEntity = async (type) => {
  try {
    const params = {
      type: type,
      apiIndex: tools.randomString()
    };
    const json = await publicService.getSimpleListByEntity(params);
    if (!json.error) {
      selectList.value = json.result;
    } else {
      Message.error(json.error?.msg || '操作失败');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '操作失败');
  }
};
// 取消
const handleCancel = () => {
  visible.value = false;
};

const handleOk = () => {
  asyncDataFormRef.value.handleSubmit();
};
// 表单提交
const handleSubmit = ({ values, errors }) => {
  console.log('values', values);
  console.log('errors', errors);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    asyncDataFormRef.value.setFields(errorArray);
    return;
  }
  if (type_invite.value) {
    inviteRefreshData();
    return;
  }

  // 同步接口
  refreshData();
};

const inviteRefreshData = async () => {
  setLoading(true);
  emits('cb', type.value, loading.value);
  try {
    const params = {
      type: type.value,
      isCustomer: false,
      isOpp: false,
      ids: undefined,
      isUserInvite: true
    };
    // ids
    if (type_invite.value && form.value.dataRadio == '1') {
      params.isOpp = true;
      params.isCustomer = true;
      params.ids = form.value.selectdata;
    }

    const json = await publicService.refreshData(params);
    if (!json.error) {
      Message.success('邀请数据同步中，同步完成后将自动刷新数据');
    } else {
      Message.error(json.error?.msg || '邀请数据同步失败，请重试!');
    }
    setLoading(false);
    visible.value = false;
    emits('cb', type.value, loading.value);
  } catch (e) {
    setLoading(false);
    visible.value = false;
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

// 数据同步接口
const refreshData = async () => {
  setLoading(true);
  // Message.success('数据同步中...');
  emits('cb', type.value, loading.value);
  try {
    const params = {
      type: type.value,
      isCustomer: false,
      isOpp: false,
      startTime: undefined,
      endTime: undefined,
      status: type.value == 3 && form.value.dataRadio == '2' ? form.value.accountStatus : undefined,
      ids: undefined
    };

    // 开始时间-结束时间
    if ((type.value == 2 && form.value.dataRadio == '1') || (type.value == 10 && form.value.dataRadio == '2')) {
      params.startTime = dayjs(form.value.timeDate[0]).format('YYYY-MM-DD HH:mm:ss');
      params.endTime = dayjs(form.value.timeDate[1]).format('YYYY-MM-DD HH:mm:ss');
    }
    if ((type.value == 3 && form.value.dataRadio == 1) || (type.value == 10 && form.value.dataRadio == '1')) {
      params.isCustomer = true;
      params.ids = form.value.selectdata;
    }
    // ids
    if (type.value == 10 && form.value.dataRadio == '1') {
      params.isOpp = true;
    }

    const json = await publicService.refreshData(params);
    if (!json.error) {
      Message.success('数据同步中，同步完成后将自动刷新数据');
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
    setLoading(false);
    visible.value = false;
    emits('cb', type.value, loading.value);
  } catch (e) {
    setLoading(false);
    visible.value = false;
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};
defineExpose({
  open
});
</script>
<style scoped lang="less">
@import './bing-data-sync.less';
</style>
